import CustomerSidebar from "./CustomerSidebar";
import { useState } from "react";
// import CardItemsComponent from "context/CardItemsProvider";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useContext } from "react";

export default function AdminLayout({ children }) {
  const auth = useContext(WithAuthentication);

  console.log("auth in customer layout", auth);
  return (
    <div dir="rtl" className="d-flex " style={{ height: "auto" }}>
      {/* <CardItemsComponent> */}
      {/* <CustomerSidebar fullName={auth.userInfo.fullName}></CustomerSidebar> */}
      <div className="pt-1 pb-4" style={{ width: "100%" }}>
        {children}
      </div>
      {/* </CardItemsComponent> */}
    </div>
  );
}
